(() => {
  const isTheme = (value) => value === "dark" || value === "light";
  let theme = "light";

  try {
    const requestedTheme = new URLSearchParams(window.location.search).get("theme");
    const savedTheme = window.localStorage.getItem("bianhua-theme");
    if (isTheme(requestedTheme)) theme = requestedTheme;
    else if (isTheme(savedTheme)) theme = savedTheme;
  } catch {
    // 首次启动或存储不可用时保持默认浅色主题。
  }

  document.documentElement.dataset.theme = theme;
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) themeColorMeta.content = theme === "light" ? "#faf9f7" : "#070708";
})();
